import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

import useExhibitors from '../useExhibitors';

const buildFilterString = ({ exhibitors }) => {
    const filterArray = [];

    // Inactive Exhibitors wanted per ICSC, do not add
    // `NOT status:Inactive` unless looking at where
    // this hook is used elsewhere.

    // Only Companies with Exhibitor ID's
    const exhibitorsFilter = exhibitors.map(exhibitor => `objectID:company-${exhibitor.recordId}`).join(' OR ');
    filterArray.push(exhibitorsFilter);

    const filterStr = filterArray.filter(f => f).join(' AND ');
    return filterStr;
};

const useExhibitorsFromCompaniesFilters = (eventCode, additionalFilters) => {
    const [filterString, setFilterString] = useState('');
    const exhibitors = useExhibitors(eventCode);

    useEffect(() => {
        if (!exhibitors || !exhibitors.length) {
            return;
        }

        const str = buildFilterString({ exhibitors });
        setFilterString(str + (additionalFilters ? ` AND ${additionalFilters}` : ''));
    }, [additionalFilters, exhibitors, filterString]);

    return { filterString };
};

useExhibitorsFromCompaniesFilters.propTypes = {
    eventCode: PropTypes.string,
    additionalFilters: PropTypes.string,
};

export default useExhibitorsFromCompaniesFilters;
